var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMobileGameDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 50,
    viewBox: "0 0 18 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48021 10.5393L3.4802 39.755H14.4606V10.5393H3.48021ZM0.0488393 9.80399C0.0488399 8.31498 1.25592 7.10791 2.74492 7.10791H15.1959C16.6849 7.10791 17.892 8.31499 17.892 9.80399V40.4903C17.892 41.9793 16.6849 43.1863 15.1959 43.1863H2.74491C1.2559 43.1863 0.0488275 41.9793 0.0488281 40.4903L0.0488393 9.80399Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 5,
    height: 2,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 2,
    height: 2,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 36,
    width: 8,
    height: 2,
    rx: 1,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9245,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMobileGameDetails);
export default __webpack_public_path__ + "static/media/ic_mobile_game_details.ed0815ca0f5bf56999872b2f10d40b3d.svg";
export { ForwardRef as ReactComponent };